module.exports = __webpack_public_path__ + "img/gestiongr.2b29bc33.jpg";